import { render, staticRenderFns } from "./detalhes-equipamentos.vue?vue&type=template&id=77b140a4&scoped=true&"
import script from "./detalhes-equipamentos.vue?vue&type=script&lang=js&"
export * from "./detalhes-equipamentos.vue?vue&type=script&lang=js&"
import style0 from "../styles/report.scss?vue&type=style&index=0&id=77b140a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b140a4",
  null
  
)

export default component.exports